module.exports = __webpack_public_path__ + "static/media/sort-right-solid-gray.f4abf277.svg";